import Toolbar from '../../../../../components/Toolbar/Toolbar';

export default Toolbar;
